import { apiCall } from "services/api";
import { readData } from "./CompanyDocumentsService";
const path = "/v1/admin/company-documents";
export const listReviewDocuments = async (queryParams) =>
  readData(await apiCall({ method: "GET", url: path, queryParams }));
export const getReviewTypes = async () =>
  readData(await apiCall({ method: "GET", url: `${path}/types` }));
export const getReviewCompanies = async () => {
  const response = await apiCall({
    method: "GET", url: "/v1/company",
    queryParams: { skip_pagination: true, sort_by: "name", sort_order: "asc" },
  });
  // Existing company master uses its own success title, unlike document APIs.
  if (response?.info?.title === "Company List" && Array.isArray(response?.data?.companies))
    return [...response.data.companies].sort((a, b) =>
      String(a.name || "").trim().localeCompare(String(b.name || "").trim(), "id", { sensitivity: "base" }) ||
      String(a.effect_code || "").trim().localeCompare(String(b.effect_code || "").trim(), "id", { sensitivity: "base" }) ||
      Number(a.company_id) - Number(b.company_id));
  throw new Error(response?.info?.description || "Unable to load issuers.");
};
export const getReviewDocument = async (id) =>
  readData(await apiCall({ method: "GET", url: `${path}/${id}` }));
export const getReviewHistory = async (id) =>
  readData(await apiCall({ method: "GET", url: `${path}/${id}/history` }));
export const reviewDocument = async (id, status, note = "") =>
  readData(
    await apiCall({
      method: "PUT",
      url: `${path}/${id}/review`,
      data: { status, note },
    }),
  );
export const getReviewFile = async (id, disposition = "attachment") => {
  const response = await apiCall({
    method: "GET",
    url: `${path}/${id}/file`,
    queryParams: { disposition },
    responseType: "blob",
  });
  if (!(response instanceof Blob))
    throw new Error("The document file is unavailable or access was denied.");
  return response;
};
